import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import common from '@/locales/pt-BR/common.json';

export const defaultNS = 'common';

export const resources = {
  'pt-BR': { common },
} as const;

void i18n.use(initReactI18next).init({
  resources,
  lng: 'pt-BR',
  fallbackLng: 'pt-BR',
  defaultNS,
  interpolation: { escapeValue: false },
});

export default i18n;
